import React from 'react';
import {
  Redirect,
  Route,
  RouteComponentProps,
  RouteProps,
} from 'react-router-dom';

interface ConditionalRouteProps extends RouteProps {
  condition: boolean;
  redirect: string;
}

export const ConditionalRoute = ({
  condition,
  redirect,
  component,
  ...rest
}: ConditionalRouteProps) => {
  if (!component) {
    return null;
  }

  const RenderRoute = (props: RouteComponentProps) =>
    condition ? (
      React.createElement(component, props)
    ) : (
      <Redirect to={redirect} />
    );

  return <Route {...rest} render={RenderRoute} />;
};
